var _g;
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
import * as React from "react";
var SvgScrollUp = function SvgScrollUp(props) {
  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    width: 60,
    height: 52
  }, props), _g || (_g = /*#__PURE__*/React.createElement("g", {
    fill: "none",
    fillRule: "evenodd"
  }, /*#__PURE__*/React.createElement("path", {
    fill: "#2C3144",
    d: "M60 26 45 51.98H15L0 26 15 .02h30z"
  }), /*#__PURE__*/React.createElement("g", {
    fill: "#FFF",
    transform: "scale(1 -1)rotate(-45 -30.698 -35.142)"
  }, /*#__PURE__*/React.createElement("rect", {
    width: 4,
    height: 20,
    rx: 2
  }), /*#__PURE__*/React.createElement("rect", {
    width: 4,
    height: 20,
    x: 8,
    y: 8,
    rx: 2,
    transform: "rotate(90 10 18)"
  })))));
};
export default SvgScrollUp;